const LOCAL_HOST = 'localhost';
const LOCAL_ALIASES = [LOCAL_HOST, '127.0.0.1'];
const ROVER_LOCAL = 'rover.local';
const ROVER_CDN_STAGING = '.roverstaging.com';
const ROVER_COM = '.rover.com';

const allowedHosts = [ROVER_LOCAL, ROVER_CDN_STAGING, ROVER_COM, ...LOCAL_ALIASES];

const BANNED_TAGS = [
  'script',
  'iframe',
  'object',
  'embed',
  'applet',
  'form',
  'input',
  'button',
  'meta',
  'style',
];

export const filterNonRoverLinks = (html: string): string => {
  const urlRegex = /<a\s+(?:[^>]*?\s+)?href="([^"]*)".*?<\/a>/gi;
  return html.replace(urlRegex, (match, url) => {
    try {
      const parsedUrl = new URL(url);
      if (!parsedUrl.host || allowedHosts.includes(parsedUrl.host)) {
        return match;
      }
    } catch (e) {
      return match;
    }
    return '';
  });
};

export const filterBannedTags = (html: string): string => {
  let resultHtml = html;
  BANNED_TAGS.forEach((tag) => {
    const tagRegex = new RegExp(`<${tag}.*?>.*?</${tag}>`, 'gi');
    resultHtml = resultHtml.replace(tagRegex, '');
  });
  return resultHtml;
};

export const sanitizeHTML = (html: string): string => {
  return filterNonRoverLinks(filterBannedTags(html));
};
